import { StreamerEntry } from "./StreamerEntry";

export class StreamerIndex
{
  streamers:StreamerEntry[];
}